export default {
    name: "IVW",

    render() {
        return
    },

    data() {
        return {
            iam_data: {}
        }
    },

    mounted() {
        this.iam_data = this.$settings.ivw.iam_data

        this.modifyCode()

        let ivwScript = document.createElement('script')
        ivwScript.setAttribute('src', this.$settings.ivw.script)
        document.head.appendChild(ivwScript)
    },

    methods: {
        modifyCode() {
            if(this.iam_data.cp) {
                this.iam_data.co = location.href
                this.iam_data.cp = this.iam_data.cp.replace(/^(.).(.*)$/, '$1v$2')
            }
        }
    },

    events: {
        jwFirstFrame(evt) {
            try {
                this.$l.log('ivw track', this.iam_data)
                if(this.$settings.environment == 'production' && this.iam_data.cp) {
                    this.$l.log('ivw track tracking')
                    iom.c(this.iam_data, 1);
                }
            } catch (err) {
                this.$l.log('IVW Tracking nicht ausführbar.', err);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/tracking/ivw.js